import Cookies from "js-cookie";
import { useFetchData, usePostData } from "utils/ReactQueryHooks";
import { isData } from "utils/HookResponse";
import { ApiResponseData } from "types/common";

export const useLicenses = () =>
  useFetchData({
    key: "licenses",
    url: "licenses",
    data: {
      aId: Cookies.get("aId"),
    },
    options: {
      select: (data: ApiResponseData) => isData(data),
    },
    post: true,
  });

export const useLicensePools = (serials: (string | null | undefined)[]) =>
  useFetchData({
    key: "licensePools",
    url: "licenses/pools",
    post: true,
    data: serials
      ?.filter((i): i is string => typeof i === "string" && i !== null)
      .map((i) => i.toLowerCase()),
    options: {
      enabled: false,
      select: (data: ApiResponseData) => isData(data),
    },
  });

export const useLicensePool = (serial: string) =>
  useFetchData({
    key: "licensePool",
    url: "licenses/pool",
    post: true,
    data: [serial?.toLowerCase()],
    options: {
      enabled: false,
      select: (data: ApiResponseData) => isData(data),
    },
  });

export const useLicenseNotificationUpdate = () =>
  usePostData({ url: "licenses/update-notification" });
